function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Group_34575",
  "data-name": "Group 34575"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_61535",
  "data-name": "Path 61535",
  d: "M33,2H11L0,21.055,11,40.105H33L44,21.055ZM26.224,31.753H11.307l1-5.318h12.58v1.477l4.394-2.87-4.394-2.87v1.537H17.777a6.681,6.681,0,0,1,0-13.362H32.7l-1,5.322H19.125V14.131L14.731,17l4.394,2.87V18.394h7.1a6.681,6.681,0,0,1,0,13.362h0Z",
  transform: "translate(0 -1.999)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("g", {
  id: "Group_34573",
  "data-name": "Group 34573",
  transform: "translate(18.374 34.175)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_62795",
  "data-name": "Path 62795",
  d: "M60.735,71.9H42.124l-4.54,7.862H56.193Z",
  transform: "translate(-37.584 -71.903)",
  fill: "#005cff"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_62796",
  "data-name": "Path 62796",
  d: "M39.854,79.944H58.463l-2.27,3.932H37.584Z",
  transform: "translate(-37.584 -76.013)",
  fill: "#ffd400"
})));

var SvgSteerLogoMobile = function SvgSteerLogoMobile(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "logo",
    width: 44,
    height: 42.038,
    viewBox: "0 0 44 42.038",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgSteerLogoMobile, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/steer-logo-mobile.e650709f.svg";
export { ForwardRef as ReactComponent };